module.exports = __webpack_public_path__ + "Roboto-Light.3c37aa69cd77e6a53a06";


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/materialize-css/dist/fonts/roboto/Roboto-Light.woff2
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Light.woff2
// module chunks = styles